import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';

const Header = () => {

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const tyreSize = params.get("tyresize");
    const user = JSON.parse(localStorage.getItem('user'))
    const { settings } = useSettings();

    // const [isLoggedIn, setIsLoggedIn] = useState(false);

    // const checkUserLoggedIn = async () => {
    //     try {
    //         const res = await fetch('https://mv-tyre.demo-customproject.com/backend/check-auth', {
    //             credentials: 'include',
    //         });

    //         const data = await res.json();

    //         if (res.ok && data.status) {
    //             console.log('User is logged in:', data.user);
    //             setIsLoggedIn(true);
    //         } else {
    //             console.warn('User is not logged in');
    //             setIsLoggedIn(false);
    //         }
    //     } catch (err) {
    //         console.error('Error checking auth status:', err);
    //         setIsLoggedIn(false);
    //     }
    // };

    // useEffect(() => {
    //     checkUserLoggedIn();
    // }, []);

    const [cartCount, setCartCount] = useState(0);

    useEffect(() => {
        const calculateCartCount = () => {
            try {
                const storedCart = localStorage.getItem("cart");
                if (storedCart) {
                    const cartItems = JSON.parse(storedCart);
                    const total = cartItems.reduce((sum, item) => sum + (item.quantity || 0), 0);
                    setCartCount(total);
                } else {
                    setCartCount(0);
                }
            } catch (err) {
                console.log("cart count error", err);
                setCartCount(0);
            }
        };
        calculateCartCount();
        window.addEventListener("storage", calculateCartCount);
        window.addEventListener("cartUpdated", calculateCartCount);
        return () => {
            window.removeEventListener("storage", calculateCartCount);
            window.removeEventListener("cartUpdated", calculateCartCount);
        };
    }, []);

    return (
        <header>
            <div className="menuSection">
                <div className="container-fluid web-padding">
                    <div className="row">
                        <div className="col-md-9 col-sm-12 d-none d-md-block header-left" data-aos="flip-left" data-aos-duration={1000}>
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="header-logo">
                                        <Link to={tyreSize ? `/?tyresize=${tyreSize}` : "/"}>
                                            {
                                                settings?.logo === null ? < img src="images/logo.png" alt="img" /> : <img src={`${settings?.logo}`} alt="img" />
                                            }
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-9">
                                    <div className="menuSec">
                                        <ul id="menu">
                                            <li><Link to={tyreSize ? `/?tyresize=${tyreSize}` : "/"} className="active">Home</Link></li>
                                            <li><Link to="/about">About US</Link></li>
                                            <li><Link to="/services">Services</Link></li>
                                            <li><Link to={tyreSize ? `/product?tyresize=${tyreSize}` : "/product"}>Products</Link></li>
                                            <li><Link to="/contact">Contact Us</Link></li>
                                            <form className="search-box" action="#/" method="get">
                                                <input type="search" name="q" id="search" placeholder="Search..." required />
                                                <button type="submit">
                                                    <i className="fas fa-search" />
                                                </button>
                                            </form>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-6 text-right" data-aos="flip-right" data-aos-duration={1000}>
                            <div className="header-right">
                                <div>
                                    <Link to="/cart" className="header-cart-icon">
                                        <img src="images/cart-icon.png" alt="img" />
                                        {cartCount > 0 && (
                                            <span className="cart_countt">{cartCount}</span>
                                        )}
                                    </Link>
                                </div>
                                <div className="log-sin-header">
                                    {user ? (
                                        <a href="https://mv-tyre.demo-customproject.com/backend/user/dashboard" >
                                            <span>Dashboard</span>
                                        </a>
                                    ) : (
                                        <>
                                            <Link to="/account">Login</Link>
                                            <Link to="/account">Sign Up</Link>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;

